// src/store/getter.js
export const isLoggedIn = state => {
  return state.loggedIn && !!state.token
}

export const userInfo = state => {
  return state.user || {}
}

export const token = state => {
  return state.token
}

export const loginLoading = state => {
  return state.loginLoading
}

export const registerLoading = state => {
  return state.registerLoading
}

export const wishLoading = state => state.wishLoading
export const wishList = state => state.wishes || []
export const wishCount = state => (state.wishes || []).length
// 其他已有的getter...
